/* @flow */
import fakeQueryResultForUser from 'auth/fakeQueryResultForUser';
import User from 'entities/User';
import gql from 'graphql-tag';
import { getApolloClientSingleton } from 'lib/apollo/client/browser';

export default function injectUserIntoApollo(user: User): void {
  const queryData = fakeQueryResultForUser(user);
  getApolloClientSingleton().writeQuery(queryData);
  const { featureFlags } = queryData.data.me;
  Object.keys(queryData.data.me.featureFlags).forEach(ff => {
    getApolloClientSingleton().writeQuery({
      data: {
        me: {
          __typename: 'User',
          uuid: queryData.data.me.uuid,
          has_feature: featureFlags[ff],
        },
      },
      query: gql`
        query Feature($feature_name: String!) {
          me {
            uuid
            has_feature(name: $feature_name)
          }
        }
      `,
      variables: { feature_name: ff },
    });
  });
}
